// CALL AXIOS TO CONSUME WEB SERVICE
import axios from "axios"
import authHeader from "../authentification/AuthHeader";

//GET URL FROM .ENV ELEMENT
import { getUrl } from "../authentification/DotenvConfig"


/**
 * URL OF APP 
 * EXAMPLE : https://exemple/api/v1
 */
 const url = getUrl()

 
/**
 * GET CATEGOIRE 
 * @returns 
 */
export async function getConditionGeneralByCategory(categorie_id) {
    try {
        const response = await axios.get(url + "condition-general/categories/"+categorie_id, { headers: authHeader() }, {
            IsEssential: true
        });
        return response;
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return (error.response);
        } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
        }
        console.log(error.config);
        return error;
    }
}
/**
 * GET CONDITIONS SPECIAL BY CATEGORY
 * @param {*} categorie_id 
 * @returns 
 */
export async function getConditionSpecialesByCategory(categorie_id) {
    try {
        const response = await axios.get(url + "condition-special/categories/"+categorie_id, { headers: authHeader() }, {
            IsEssential: true
        });
        return response;
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return (error.response);
        } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
        }
        console.log(error.config);
        return error;
    }
}